import { useEffect, useState } from "react";
import { Card, Form, Table } from "react-bootstrap";
import InvoiceTableRow from "./InvoiceTableRow";
import InvoiceTableFilters from "./InvoiceTableFilters";
import { FaSquareXmark } from "react-icons/fa6";
import EnergoPagination from "../../shared/EnergoPagination";

const InvoiceTable = ({ allInvoices, selectedAnlage }) => {

    const [invoices, setInvoices] = useState(allInvoices);
    const [downloadList, setDownloadList] = useState([]);
    const [allCheckboxesChecked, setAllCheckboxesCheked] = useState(false);
    const [filtersActive, setFiltersActive] = useState(false);
    const [filters, setFilters] = useState({
        documentsPerPage: 5,
        documentFrom: null,
        documentType: null,
        monthRange: [1, 12],
        year: null,
        isDownloaded: null,
        availableDocumentTypes: [],
        availableYears: [...new Set(allInvoices.map(obj => (obj.x_rechnungsdatum || obj.x_eingangsdatum || obj.create_date)?.split("-")[0]))].sort((a, b) => b - a),
        currentPaginationPage: 0,
    });

    useEffect(() => {
        var tmp = ["Abrechnung Energie", "Vorschreibung Energie"];
        allInvoices.forEach(inv => {
            if (inv.x_rechnungsart && !tmp.includes(`${inv.x_rechnungsart} ENERGO`)) {
                tmp.push(`${inv.x_rechnungsart} ENERGO`);
            }
            if (inv.x_is_final_invoice === true && !tmp.includes("Endrechnung Energie")) {
                tmp.push("Endrechnung Energie");
            }
        });
        setFilters(f => ({
            ...f,
            availableDocumentTypes: tmp
        }));
    }, [allInvoices])

    useEffect(() => {
        var active = false;
        var temp = allInvoices;

        if (selectedAnlage.length > 0) {
            temp = temp.filter(i => i.x_anlage_id.length > 0 && i.x_anlage_id[0] === selectedAnlage[0]);
        }

        if (filters.documentFrom === "ENERGO") {
            active = true;
            temp = temp.filter(i => i.x_file_poolrechnung_name !== undefined);
        }
        else if (filters.documentFrom === "Energielieferant") {
            active = true;
            temp = temp.filter(i => i.x_file_poolrechnung_name === undefined);
        }

        if (filters.documentType !== null) {
            if (filters.documentType.includes("ENERGO")) {
                active = true;
                var x_rechnungsart = filters.documentType.split(" ")[0];
                temp = temp.filter(i => i.x_rechnungsart === x_rechnungsart);
            } else {
                if (filters.documentType.includes("Endrechnung")) {
                    active = true;
                    temp = temp.filter(i => i.x_is_final_invoice === true);
                }
                else if (filters.documentType.includes("Vorschreibung")) {
                    active = true;
                    temp = temp.filter(i => i.x_file_vorschreibung_name !== undefined);
                } else {
                    active = true;
                    temp = temp.filter(i => i.x_is_final_invoice === false && i.x_file_abrechnung_name !== undefined);
                }
            }
        }

        if (filters.monthRange !== null) {
            const [fromMonth, toMonth] = filters.monthRange;
            temp = temp.filter(i => {
                const date =
                    i.x_rechnungsdatum ||
                    i.x_eingangsdatum ||
                    i.create_date;

                if (!date) return false;

                const month = Number(date.split("-")[1]);
                return month >= fromMonth && month <= toMonth;
            })
        }
        if (filters.year !== null) {
            active = true;
            temp = temp.filter(obj =>
                (obj.x_rechnungsdatum || obj.x_eingangsdatum || obj.create_date)?.startsWith(filters.year.toString())
            );
        }

        if (filters.isDownloaded === true) {
            active = true;
            temp = temp.filter(i => i.x_datum_download !== "False" && i.x_datum_download !== false);
        }
        else if (filters.isDownloaded === false) {
            active = true;
            temp = temp.filter(i => i.x_datum_download === "False" || i.x_datum_download === false);
        }

        //temp = temp.slice(0, filters.documentsPerPage);
        setInvoices(temp);
        setFiltersActive(active);
    }, [filters])


    const toggleCheckboxes = () => {
        const checkboxes = document.querySelectorAll(".invoice-checkbox input");

        if (allCheckboxesChecked) {
            checkboxes.forEach(cb => {
                cb.checked = false;
            });
            setDownloadList([]);

        } else {
            const newDownloadList = [];

            checkboxes.forEach(cb => {
                cb.checked = true;
                const inv = cb.id.split(":");
                newDownloadList.push({
                    type: inv[0],
                    id: inv[1]
                });
            });

            setDownloadList(newDownloadList);
        }
        setAllCheckboxesCheked(!allCheckboxesChecked);
    }

    const downloadListSingleToggleHandler = (checkbox) => {
        const invId = checkbox.split(":")[1];
        const exists = downloadList.some(i => i.id === invId);

        if (exists) {
            setDownloadList(downloadList.filter(i => i.id !== invId));
        
        } else {
            setDownloadList(prev => [
                ...prev,
                {
                    type: checkbox.split(":")[0],
                    id: invId
                }
            ]);
        }
    }

    const resetAllFilters = () => {
        setFilters({
            ...filters,
            documentFrom: null,
            documentType: null,
            monthRange: [1, 12],
            year: null,
            isDownloaded: null,
        })
    }

    const changePaginationPage = (newPage) => {
        setFilters(f => ({
            ...f,
            currentPaginationPage: newPage
        }));
    }

    return (
        <>
            <div className="d-flex m-3 justify-content-between align-items-center">
                <div>
                    <a 
                        hidden={!filtersActive} 
                        className="link-energo" 
                        href="filters/reset/" 
                        onClick={e => { e.preventDefault(); resetAllFilters() }}
                    >
                        <FaSquareXmark size={30} className="me-2" />
                        aktuelle Filters zurücksetzen
                    </a>
                </div>
                <div hidden>
                    <Form.Select
                        defaultValue={filters.documentsPerPage}
                        onChange={e => setFilters({ ...filters, documentsPerPage: Number(e.target.value) })}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </Form.Select>
                    <span>pro Seite</span>
                </div>
            </div>
            <Card style={{ borderRadius: "15px", borderBottom: "3px solid #a2c13f", borderLeft: "3px solid #a2c13f" }} className="mt-3 shadow-lg">
                <Card.Header>
                    <InvoiceTableFilters filters={filters} setFilters={setFilters} downloadList={downloadList} />
                </Card.Header>

                <Card.Body>
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th><Form.Check type="checkbox" onChange={() => toggleCheckboxes()} /></th>
                                <th>Von</th>
                                <th>Rechnungsart</th>
                                <th>Datum</th>
                                <th>Anlage</th>
                                <th>Brutto</th>
                                <th className="text-center">Downloaded</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.map(inv => (
                                <InvoiceTableRow key={inv.id} invoice={inv} singleSelectHandler={downloadListSingleToggleHandler} />
                            ))}

                            {!invoices || invoices.length === 0 &&
                                <tr>
                                    <td className="text-center" colSpan={7}>Keine Rechnungen gefunden</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    )
}

export default InvoiceTable;